import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { GetApplicationNoticeQuery } from '@graphql/bifrost/generated';
import { appNoticeActions } from './app-notice.actions';

export const featureKey = 'appNotices';
export type AppNotice = GetApplicationNoticeQuery['applicationNotice'];
export interface AppNoticesState extends EntityState<AppNotice> {
  activeAppNotice: AppNotice | null;
  conflictingNotice: {
    isLoading: boolean;
    conflictingNotice?: { title: string; startTime: string; endTime: string };
    error?: any;
  };
}
export const adapter: EntityAdapter<AppNotice> =
  createEntityAdapter<AppNotice>();
export const initialState: AppNoticesState = adapter.getInitialState({
  activeAppNotice: null,
  conflictingNotice: {
    isLoading: false,
    conflictingNotice: undefined,
    error: undefined,
  },
});
export const reducer = createReducer(
  initialState,
  on(appNoticeActions.loadAllSuccess, (state, action) =>
    adapter.setAll(action.notices, state)
  ),
  on(appNoticeActions.loadOneSuccess, (state, action) =>
    adapter.addOne(action.notice, state)
  ),
  on(appNoticeActions.createSuccess, (state, action) =>
    adapter.addOne(action.notice, state)
  ),
  on(appNoticeActions.updateSuccess, (state, action) =>
    adapter.updateOne(action.notice, state)
  ),
  on(appNoticeActions.loadActiveSuccess, (state, action) => ({
    ...state,
    activeAppNotice: action.notice,
  })),
  on(appNoticeActions.checkConflict, (state) => ({
    ...state,
    conflictingNotice: {
      ...state.conflictingNotice,
      isLoading: true,
      error: undefined,
    },
  })),
  on(appNoticeActions.checkConflictSuccess, (state, action) => ({
    ...state,
    conflictingNotice: {
      isLoading: false,
      conflictingNotice: action.conflictingNotice,
      error: undefined,
    },
  })),
  on(appNoticeActions.checkConflictFailure, (state, action) => ({
    ...state,
    conflictingNotice: {
      isLoading: false,
      conflictingNotice: undefined,
      error: action.error,
    },
  }))
);
export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();
